import { Box } from "./Box";

export const TwoButtonBox = ({ children, ...props }) => {
    return <Box width={{ xs: "100%", md: "auto" }}>{children}</Box>;
};
